import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
// import commonEN from '../locales/en/common.json';
// import loginEN from '../locales/en/login.json';
// import headerEN from '../locales/en/header.json';
// import sidebarEN from '../locales/en/navbar.json';

const PRODUCTION_MODE = 'production';
const localesPath = '/locales/{{lng}}/{{ns}}.json';

const detectionOptions = {
	order: ['querystring', 'cookies', 'navigator', 'localStorage'],
};

i18n
	.use(initReactI18next)
	.use(LngDetector)
	.use(Backend)
	.init({
		defaultNS: 'common',
		ns: ['common'],
		detection: detectionOptions,
		whitelist: [
			'en',
			// 'fr',
			'es',
			// 'pt',
			// 'ru',
			// 'de',
			'ja',
			// 'it',
			// 'zh',
			// 'ar',
			// 'ko',
		],
		interpolation: { escapeValue: false },
		debug: process.env.NODE_ENV !== PRODUCTION_MODE,
		fallbackLng: 'en',
		load: 'languageOnly',
		backend: {
			loadPath: localesPath,
		},
	});
